const batchUserTypeProcess = [
  {
    id: 0,
    name: '選択なし',
    value: ''
  },
  {
    id: 1,
    name: '登録',
    value: 'REGISTER'
  },
  {
    id: 2,
    name: '更新',
    value: 'CHANGE_EMAIL'
  }
];

export default batchUserTypeProcess;
